export const initialState = {
  search: '',
};
